module.exports = __webpack_public_path__ + "static/img/af.008dc322.svg";